import * as React from 'react';
import classNames from 'classnames';
import './checkCard.module.scss';
import { CheckBox } from '@sheinc/design-system';

type Props = {
  title: string;
  text: string;
  checked: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCheck: (checked: boolean) => any;
};

export const CheckCard = ({ title, text, checked, onCheck }: Props) => (
  <div styleName={classNames('check-card-wrapper', { checked: checked })}>
    <div styleName="description-area">
      <div styleName="title">{title}</div>
      <div styleName="text">{text}</div>
    </div>
    <div className="check-area" styleName="check-area" onClick={() => onCheck(!checked)}>
      <CheckBox checked={checked}>同意する</CheckBox>
    </div>
  </div>
);
